import apiClient from '../index';

export const createRole = async (data) => {
  try {
    const response = await apiClient.post('/api/role/', data);
    return response.data;
  } catch (error) {
    console.error(`Error on creating role`, error);
    throw error;
  }
};

export const getAllRoles = async () => {
  try {
    const response = await apiClient.get('/api/role/');
    return response.data;
  } catch (error) {
    console.error(`Error on fetching roles`, error);
    throw error;
  }
};

export const getRoleById = async (id) => {
  try {
    const response = await apiClient.get(`/api/role/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error on fetching role`, error);
    throw error;
  }
};

export const updateRoleById = async ([id, data]) => {
  try {
    const response = await apiClient.put(`/api/role/${id}`, data);
    return response.data;
  } catch (error) {
    console.error(`Error on updating role`, error);
    throw error;
  }
};

export const deleteRoleById = async (id) => {
  try {
    const response = await apiClient.delete(`/api/role/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error on deleting role`, error);
    throw error;
  }
};
